export default __webpack_public_path__ + "static/media/expert_rent.a32a3c9b.svg";